import { View } from 'react-native'
import styled from 'styled-components/native'

export const Separator = styled(View)`
  border: 1px solid #d1d3d4;
  margin: 20px 8px;
`

export const HeaderIcon = styled(View)`
  position: absolute;
  top: 15px;
  right: 15px;
`
